<template>
  <PaginatedTable :columns :current-page :data @page-change="handlePageChange">
    <template #body-market="{ item }">
      <Flag aria-hidden="true" class="mr-4" :country-code="item.market" />
      <span class="body-1-bold">{{ item.market }}</span>
    </template>

    <template #body-orderId="{ item }">
      <RevLink
        :to="{
          type: 'internal',
          name: ROUTE_NAMES.ORDERS.INDEX,
          query: {
            orderId: item.orderId,
          },
        }"
      >
        {{ item.orderId }}
      </RevLink>
    </template>

    <template #body-creationDate="{ item }">
      <span class="whitespace-nowrap">{{ item.creationDate }}</span>
    </template>

    <template #body-rate="{ item }">
      <RevRating :score="item.rate" size="small" />
    </template>
  </PaginatedTable>
</template>

<script setup lang="ts">
import { navigateTo, useRoute } from '#imports'
import { computed } from 'vue'

import type { GetReviews } from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'
import { RevRating } from '@ds/components/Rating'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './ReviewsTable.translations'

const i18n = useI18n()

defineProps<{
  data: GetReviews
}>()

const route = useRoute()
const currentPage = computed(
  () => parseInt(route.query.page?.toString() || '', 10) || 1,
)

const columns = [
  { key: 'market', label: i18n(translations.market) },
  {
    key: 'orderId',
    label: i18n(translations.orderId),
    isTabular: true,
    headerClassNames: 'whitespace-nowrap',
  },
  {
    key: 'creationDate',
    label: i18n(translations.creationDate),
    isTabular: true,
  },
  { key: 'customer', label: i18n(translations.customer) },
  { key: 'rate', label: i18n(translations.rate) },
  { key: 'comment', label: i18n(translations.comment) },
]

async function handlePageChange({ page }: { page: number }) {
  navigateTo({ ...route, query: { page } })
}
</script>
